export default {
  LIGHT: {
    MAIN: {
      PRIMARY: '#056cf2',
      SECONDARY: '#020126',
      SUCCESS: '#14c458',
      ERROR: '#f73e55',
      WARNING: '#ffd500',
      INFO: '#0184F7'
    },
    NEUTRAL: {
      BACKGROUND: '#ffffff',
      CARD: '#ffffff',
      SIDE: '#F3F3F3',
      SELECTED: '#E0E0E0',
      TRANSPARENT: 'transparent'
    },
    FONT: {
      TITLE: '#1e1926',
      DESCRIPTION: '#8a8a8a',
      HELPER: '#696974',
      CONTRAST: '#ffffff'
    }
  },
  DARK: {
    MAIN: {},
    NEUTRAL: {},
    FONT: {}
  }
}
